<div class="modal-body">
  <div class="modal-group">
    <div class="modal-group-title">Status</div>
    <div class="modal-row">
      <div class="modal-label">
        <label for="countryEnabled">Country status</label>
        <i class="fa-regular fa-circle-question fa-xl text-primary cursor-help"
           pTooltip="Deactivating a country stops it appearing in the Country dropdown when adding or editing a location."></i>
      </div>
      <div class="state-switch">
        <span class="state-tag" [class.on]="!localData.enabled" (click)="localData.enabled = false">Inactive</span>
        <p-toggleswitch inputId="countryEnabled" [(ngModel)]="localData.enabled" />
        <span class="state-tag" [class.on]="localData.enabled" (click)="localData.enabled = true">Active</span>
      </div>
    </div>
  </div>

  <div class="modal-divider"></div>

  <div class="modal-group">
    <div class="modal-group-title">Country Details</div>
    <div class="modal-row">
      <div class="modal-label">
        <label for="countryName">Country name<span class="req">*</span></label>
      </div>
      <input id="countryName" type="text" pInputText [(ngModel)]="localData.name"
             placeholder="Enter a country name..." class="flex-1 min-w-0" />
    </div>
    <div class="modal-row">
      <div class="modal-label">
        <label for="costGroup">Cost group<span class="req">*</span></label>
        <i class="fa-regular fa-circle-question fa-xl text-primary cursor-help"
           pTooltip="Set by the ATO in its annual Taxation Determination. Countries not listed by the ATO use cost group 3."></i>
      </div>
      <p-select inputId="costGroup"
                [(ngModel)]="localData.costGroup"
                [options]="costGroupOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select a cost group..."
                appendTo="body"
                class="flex-1 min-w-0" />
    </div>
  </div>

  <div class="modal-footer">
    <p-button label="Save" icon="fa-regular fa-save" [disabled]="!canSave" (click)="closeDialog(localData)" />
    <p-button label="Cancel" severity="danger" icon="fa-regular fa-cancel" (click)="closeDialog()" />
  </div>
</div>
